import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store';

export interface UserProfile {
  userID: string,
  userSig: string
}

const initialState: UserProfile = {
  userID: '',
  userSig: '',
}

const userProfile = createSlice({
  name: 'userProfile',
  initialState,
  reducers: {
    setCredentials: (
      state,
      { payload: { userID, userSig } }: PayloadAction<{ userID: string; userSig: string }>
    ) => {
      state.userID = userID
      state.userSig = userSig
    },
  },
})

export const { setCredentials } = userProfile.actions

export default userProfile.reducer

export const selectCurrentUser = (state: RootState) => state.userProfile;
